import { render, staticRenderFns } from "./SnippetAudio.vue?vue&type=template&id=2597a9d0&scoped=true"
import script from "./SnippetAudio.vue?vue&type=script&lang=js"
export * from "./SnippetAudio.vue?vue&type=script&lang=js"
import style0 from "./SnippetAudio.vue?vue&type=style&index=0&id=2597a9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597a9d0",
  null
  
)

export default component.exports